import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2cd04802")

_pushScopeId("data-v-2cd04802")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = { class: "form__input" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("의사변경")
const _hoisted_4 = { class: "doctor-description" }
const _hoisted_5 = { class: "input__purpose" }
const _hoisted_6 = { class: "input__purpose-other" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "purpose",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode("주증상 입력"),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, " (필수)")
], -1)
const _hoisted_8 = { class: "input__files" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "purpose",
  class: "-medium"
}, "파일 첨부", -1)
const _hoisted_10 = {
  key: 0,
  class: "request__footer"
}
const _hoisted_11 = { class: "footer__doctor" }
const _hoisted_12 = { class: "label -medium" }
const _hoisted_13 = { class: "value -bold" }
const _hoisted_14 = { class: "footer__datetiem" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "label -medium" }, "희망 일/시 선택", -1)
const _hoisted_16 = { class: "value -bold" }
const _hoisted_17 = { class: "request-form__footer--actions" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("저장하기")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("이전")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("변경하기")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_DoctorScheduled = _resolveComponent("DoctorScheduled")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_FileList = _resolveComponent("FileList")
  const _component_FileUploader = _resolveComponent("FileUploader")
  const _component_PharmacyList = _resolveComponent("PharmacyList")
  const _component_Doctors = _resolveComponent("Doctors")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      (!_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            class: "second-opinion__request__form",
            action: "",
            method: "",
            onSubmit: _ctx.saveConfirm
          }, {
            default: _withId(() => [
              (!!_ctx.alert.content)
                ? (_openBlock(), _createBlock(_component_Alert, {
                    key: 0,
                    alert: _ctx.alert,
                    "onUpdate:clear": _cache[1] || (_cache[1] = 
            () => {
              _ctx.alert.content = '';
            }
          )
                  }, null, 8, ["alert"]))
                : _createCommentVNode("", true),
              _createVNode(_component_CustomConfirmDialog, { group: "save" }),
              _createVNode(_component_CustomConfirmDialog, {
                group: "confirm",
                isConfirm: true
              }),
              _createVNode(_component_PageFrame, { class: "form__content" }, {
                title: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.pageType === _ctx.PageTypes.QUICK ? "빠른 " : "") + "진료 신청 수정 ", 1)
                ]),
                content: _withId(() => [
                  _createVNode("div", _hoisted_2, [
                    (_ctx.state.page === _ctx.PageStates.PURPOSE)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          (!!_ctx.doctors.selectedDoctor)
                            ? (_openBlock(), _createBlock(_component_DoctorItem, {
                                key: 0,
                                doctor: _ctx.doctors.selectedDoctor[0]
                              }, {
                                desc: _withId(() => [
                                  _createVNode("span", {
                                    class: "description-more -medium -royalBlue",
                                    onClick: _cache[2] || (_cache[2] = 
                        (event) =>
                          _ctx.opToggle(event, _ctx.doctors.selectedDoctor[0].Profiles)
                      )
                                  }, "프로필 상세보기")
                                ]),
                                button: _withId(() => [
                                  _createVNode(_component_Button, {
                                    class: "-button",
                                    onClick: _cache[3] || (_cache[3] = 
                        () => {
                          _ctx.state.page = _ctx.PageStates.DOCTOR;
                        }
                      )
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["doctor"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_OverlayPanel, {
                            showCloseIcon: true,
                            ref: "op$"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_4, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descMore.split('\n'), (p, i) => {
                                  return (_openBlock(), _createBlock("span", { key: i }, _toDisplayString(p), 1))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }, 512),
                          _createVNode("div", _hoisted_5, [
                            (_ctx.state.pageType !== _ctx.PageTypes.QUICK)
                              ? (_openBlock(), _createBlock(_component_DoctorScheduled, {
                                  key: 0,
                                  purpose: _ctx.state.purpose,
                                  timeList: _ctx.timeList,
                                  isEditable: _ctx.isEditable,
                                  doctorScheduled: _ctx.doctorScheduled,
                                  required: true,
                                  isLine: false
                                }, null, 8, ["purpose", "timeList", "isEditable", "doctorScheduled"]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_6, [
                              _hoisted_7,
                              _createVNode(_component_Textarea, {
                                id: "purpose",
                                modelValue: _ctx.state.purpose.other,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.purpose.other = $event)),
                                rows: "12",
                                cols: "36"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_8, [
                            _hoisted_9,
                            (_ctx.state.purpose.files && _ctx.state.purpose.files.length > 0)
                              ? (_openBlock(), _createBlock(_component_FileList, {
                                  key: 0,
                                  class: "upload-files",
                                  list: _ctx.state.purpose.files,
                                  onDeletedFile: _ctx.deletedFile,
                                  id: _ctx.state.id,
                                  requestKind: _ctx.RequestKindTypes.SecondOpinion
                                }, null, 8, ["list", "onDeletedFile", "id", "requestKind"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FileUploader, {
                              ref: "fileUploader$",
                              isEditable: true,
                              onProgress: _ctx.filesProgress,
                              isAllowVideo: true,
                              isAllowZip: true,
                              url: _ctx.url,
                              class: "file-uploader"
                            }, null, 8, ["onProgress", "url"])
                          ]),
                          (
                    _ctx.isEditable || (!_ctx.isEditable && _ctx.state.purpose.pharmacyKey > 0)
                  )
                            ? (_openBlock(), _createBlock(_component_PharmacyList, {
                                key: 1,
                                onItemSelect: _ctx.updatePharmacyKey,
                                isDefault: false,
                                selectedKey: _ctx.state.purpose.pharmacyKey,
                                isEditable: _ctx.isEditable,
                                requestStatus: _ctx.state.requestStatus
                              }, null, 8, ["onItemSelect", "selectedKey", "isEditable", "requestStatus"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_Doctors, {
                          key: 1,
                          pDoctors: _ctx.doctors,
                          "onUpdate:pDoctors": _cache[5] || (_cache[5] = ($event: any) => (_ctx.doctors = $event)),
                          onSelectDoctor: _ctx.selectDoctor,
                          possibleTypes: _ctx.PossibleTypes.SECOND_OPINION,
                          doctorKey: _ctx.state.purpose.doctorKey,
                          isEditable: true,
                          ref: "doctors$"
                        }, null, 8, ["pDoctors", "onSelectDoctor", "possibleTypes", "doctorKey"]))
                  ])
                ]),
                footer: _withId(() => [
                  (
                !!_ctx.doctors.selectedDoctor && _ctx.doctors.selectedDoctor.length > 0
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.doctors.selectedDoctor[0].DeptName), 1),
                          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.doctors.selectedDoctor[0].DoctorName), 1)
                        ]),
                        _createVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode("span", _hoisted_16, _toDisplayString(!!_ctx.state.purpose.date ? _ctx.selectDate : "-") + " " + _toDisplayString(!!_ctx.state.purpose.time ? " / " + _ctx.state.purpose.time : ""), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                action: _withId(() => [
                  _createVNode("div", _hoisted_17, [
                    (_ctx.state.page === _ctx.PageStates.PURPOSE)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "-button -royalBlue",
                          type: "submit"
                        }, {
                          default: _withId(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.state.page === _ctx.PageStates.DOCTOR)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_Button, {
                            class: "-button -waikawaGrey",
                            type: "button",
                            onClick: _cache[6] || (_cache[6] = 
                    () => {
                      _ctx.state.page = _ctx.PageStates.PURPOSE;
                    }
                  )
                          }, {
                            default: _withId(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "-button -royalBlue",
                            onClick: _cache[7] || (_cache[7] = 
                    () => {
                      _ctx.changedDoctor();
                      _ctx.state.page = _ctx.PageStates.PURPOSE;
                    }
                  )
                          }, {
                            default: _withId(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ])
  ]))
})